import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';
import { BlockItemContent } from '@/models/Blocks/Itens/Types/block-content-types';


export class BlockWhy extends BlockItem {
    protected _title: BlockItemContent;
    protected _subtitle: BlockItemContent;
    protected _cssClass?: string;

    public constructor(title: BlockItemContent, subtitle: BlockItemContent) {
        super(BlockItemType.why);
        this._title = title;
        this._subtitle = subtitle;
    }

    public get subtitle(): BlockItemContent{
        return this._subtitle;
    }

    public set subtitle(value: BlockItemContent) {
        this._subtitle = value;
    }

    public get title(): BlockItemContent{
        return this._title;
    }

    public set title(value: BlockItemContent) {
        this._title = value;
    }
    public get cssClass(): string|undefined {
        return this._cssClass;
    }

    public set cssClass(value: string|undefined) {
        this._cssClass = value;
    }
}